import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltPresenceAvatarListItemWireframe from './VeltPresenceAvatarListItemWireframe/VeltPresenceAvatarListItemWireframe';
var VeltPresenceAvatarListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-presence-avatar-list-wireframe", __assign({}, transformedProps), children));
};
VeltPresenceAvatarListWireframe.Item = VeltPresenceAvatarListItemWireframe;
export default VeltPresenceAvatarListWireframe;
